// extracted by mini-css-extract-plugin
export default {"container":"number-column-statistics-footer__container___bcdAb","label":"number-column-statistics-footer__label___sAQ0l","value":"number-column-statistics-footer__value___ct3LG"};